import { render } from "./SimulationDisplay.vue?vue&type=template&id=ac481570&scoped=true&ts=true"
import script from "./SimulationDisplay.vue?vue&type=script&lang=ts"
export * from "./SimulationDisplay.vue?vue&type=script&lang=ts"

import "./SimulationDisplay.vue?vue&type=style&index=0&id=ac481570&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac481570"]])

export default __exports__